import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { Counters, ShareButton } from '../components';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

interface CardActionsBlockProps extends BlockProps {
  withTopDivider?: boolean;
  withBottomDivider?: boolean;
  setIsDropDownOpen?: (value: boolean) => void;
}

export function CardActionsBlock({
  setIsDropDownOpen,
  withTopDivider = false,
  withBottomDivider = false,
  ...forwardingProps
}: CardActionsBlockProps) {
  const { url } = usePost();
  const { showActions, textColor } = usePostSettings();

  if (!showActions) {
    return null;
  }

  return (
    <>
      {withTopDivider && (
        <CardLayout.Block>
          <Divider _color={textColor} />
        </CardLayout.Block>
      )}

      <CardLayoutBlock {...forwardingProps} _noShrink>
        <Counters color={textColor} />

        <ShareButton
          url={url}
          color={textColor}
          setIsDropDownOpen={setIsDropDownOpen}
        />
      </CardLayoutBlock>

      {withBottomDivider && (
        <CardLayout.Block>
          <Divider _color={textColor} />
        </CardLayout.Block>
      )}
    </>
  );
}

const Divider = styled.div.attrs<{ _color: string }>({
  className: createReadableClass({
    component: 'card-actions-block',
    element: 'divider'
  })
})`
  width: 100%;
  height: 1px;
  opacity: 0.1;
  background-color: ${({ _color }) => _color};
`;

const CardLayoutBlock = styled(CardLayout.Block).attrs({
  className: createReadableClass({
    component: 'card-actions-block',
    element: 'layout-block'
  })
})`
  display: flex;
  width: 100%;
  gap: 16px;
`;
